import { Card, Col, Row } from "antd";
import moment from "moment";
import { getSubscriptionUserInfo, getUserInfo } from "../../utils/utils";

import companyName from "../../assets/svg/companyName.svg";
import email from "../../assets/svg/email-grey.svg";
import phone from "../../assets/svg/phone-grey.svg";
import daysLeft from "../../assets/svg/days-left.svg";
import activation from "../../assets/svg/activation-date.svg";
import renewal from "../../assets/svg/renewal-date.svg";

const UserInfo = () => {
  const userAccountInfo = getUserInfo();
  const subscriptionInfo = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscriptionInfo?.validTo);
  const isExpired = validToDate.isBefore(currentDate);
  return (
    <Card
      title={<div className="heading18px fw-bold">Profile Information</div>}
      className="rounded-2xl shadow-md border"
    >
      <div className="d-flex flex-column flex-md-row gap-30">
        <div>
          <div
            className="bg-muted heading32px fw-bold rounded-lg w-99 h-99 d-flex align-items-center justify-content-center"
            style={{ textTransform: "uppercase" }}
          >
            {userAccountInfo?.firstName?.trim()?.[0]}
            {userAccountInfo?.lastName?.trim()?.[0]}
          </div>
        </div>
        <Row gutter={[30, 30]} className="justify-content-between">
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={companyName} alt="" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Company Name
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>{userAccountInfo?.companyName}</Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={email} alt="" className="w-15 h-15" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Email
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>{userAccountInfo?.email}</Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={phone} alt="" className="w-15 h-15" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Phone
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>{userAccountInfo?.mobileNo}</Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-color-888888 text-center">
                <i className="fa fa-dollar-sign" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Subscription
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>{subscriptionInfo?.subscriptionPackage?.name}</Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={daysLeft} alt="" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Days Left
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>
                {isExpired ? (
                  "Expired"
                ) : (
                  <>
                    {moment(subscriptionInfo?.validTo).diff(moment(), "days")}{" "}
                    out of{" "}
                    {moment(subscriptionInfo?.validTo).diff(
                      moment(subscriptionInfo?.trialPeriodStartDate),
                      "days"
                    )}{" "}
                    days
                  </>
                )}
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={activation} alt="" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Activation Date
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>
                {" "}
                {moment(subscriptionInfo?.trialPeriodStartDate).format(
                  "D, MMMM YYYY"
                )}
              </Col>
            </Row>
          </Col>
          <Col xs={24} md={8}>
            <Row gutter={[5, 0]} className="align-items-center">
              <Col xs={3} className="text-center">
                <img src={renewal} alt="" />
              </Col>
              <Col xs={21} className="text-color-888888">
                Renewable Date
              </Col>
              <Col xs={3}></Col>
              <Col xs={21}>
                {moment(subscriptionInfo?.validTo).format("D, MMMM YYYY")}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default UserInfo;
